import Logo from "./Logo";

export default function Footer() {
  return (
    <>
      <footer className="site-footer">
        <div className="footer-wordmark" aria-hidden="true">PlaySlot</div>

        <div className="footer-cta">
          <div>
            <div className="disp" style={{ fontWeight: '800', fontSize: 'clamp(20px, 2.2vw, 28px)', letterSpacing: '-.02em' }}>Run your sports facility. Let players focus on the game.</div>
            <p style={{ fontSize: '14.5px', color: 'var(--ink-3)', marginTop: '8px' }}>A 30-minute walkthrough, built around your courts.</p>
          </div>
          <a className="btn btn-primary" href="#demo">Request a Demo</a>
        </div>

        <div className="footer-cols">
          <div>
            <a className="brand" href="#top" aria-label="PlaySlot home">
              <Logo size={30} motion="idle" />
              <span className="brand-name" style={{ fontSize: '18px' }}>PlaySlot</span>
            </a>
            <p className="footer-blurb">
              The sports facility operating system &mdash; reservations, memberships, events, coaching, payments and analytics in one platform.
            </p>
            <div className="socials">
              <a href="[INSTAGRAM URL]" aria-label="PlaySlot on Instagram">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="5"></rect><circle cx="12" cy="12" r="4"></circle><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"></circle></svg>
              </a>
              <a href="[LINKEDIN URL]" aria-label="PlaySlot on LinkedIn">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><rect x="3" y="3" width="18" height="18" rx="4"></rect><path d="M8 10v7M8 7v.5M12 17v-4a2 2 0 0 1 4 0v4"></path></svg>
              </a>
              <a href="[YOUTUBE URL]" aria-label="PlaySlot on YouTube">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><rect x="2.5" y="5.5" width="19" height="13" rx="4"></rect><path d="M10.5 9.5 15 12l-4.5 2.5z"></path></svg>
              </a>
              <a href="[X URL]" aria-label="PlaySlot on X">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" aria-hidden="true"><path d="M4 4l16 16M20 4L4 20"></path></svg>
              </a>
            </div>
          </div>

          <div>
            <h4>PLATFORM</h4>
            <div className="footer-links">
                <a href="#features">Features</a>
              <a href="#sports">Sports</a>
              <a href="#plans">Plans</a>
            </div>
          </div>

          <div>
            <h4>MODULES</h4>
            <div className="footer-links">
              <a href="#features">Reservations</a>
              <a href="#features">Events</a>
              <a href="#features">Coach Connect</a>
              <a href="#features">Memberships</a>
              <a href="#features">Payments</a>
              <a href="#features">Analytics</a>
            </div>
          </div>

          <div>
            <h4>COMPANY</h4>
            <div className="footer-links">
              <a href="#about">About</a>
              <a href="#demo">Request a Demo</a>
              <a href="#plans">Pricing</a>
            </div>
          </div>

          <div>
            <h4>CONTACT</h4>
            <div className="footer-links">
              <a href="mailto:project@mobmaxime.com">project@mobmaxime.com</a>
              <a href="tel:+17823772840">+1 (782) 377-2840</a>
              <span style={{ color: 'var(--ink-4)', fontSize: '14px', lineHeight: '1.6' }}>LaunchPad PEI<br />Charlottetown, PE C1A 4L1, Canada</span>
            </div>
          </div>
        </div>

        <div className="footer-base">
          <span>&copy; <span data-year>2026</span> PlaySlot. All rights reserved.</span>
          <span className="footer-legal">
            <a href="#demo">Privacy Policy</a>
            <a href="#demo">Terms of Use</a>
            <a href="#demo">Cookie Policy</a>
          </span>
        </div>
      </footer>
    </>
  );
}
